import gregAvatar from '../../assets/gregAvatar.jpeg'
import julianAvatar from '../../assets/julianAvatar.jpeg'
import patrickAvatar from '../../assets/patrickAvatar.jpeg'
import qaziAvatar from '../../assets/qaziAvatar.jpeg'



const tutorData=[
    {
        image:patrickAvatar,
        name: "Patrick collins",
        review: "Patrick collins makes learning solidity fun and exciting and creates advanced smart contract development tutorial course including a 30 hour fully loded beginner course.",
        link:  "https://www.youtube.com/c/PatrickCollins"

    },
    {
        image:gregAvatar,
        name: "Gergory from Dapp university",
        review: "Gregory trains beginners in web3 space via his bootcamp proqram and numerous free youtube videos on his youtub channel. He focuses mainly on decentralized applications.",
        link: "https://www.youtube.com/c/DappUniversity"

    },
    {
        image:julianAvatar,
        name: "Julian from Eat the blocks",
        review: "Julian provides high quality web3 tutorial videos with practical example implementation for smart contracts, decentralized applications and backend frame works in a highly easy to understand manner.",
        link: "https://www.youtube.com/c/EatTheBlocks"


    },
    {
        image:qaziAvatar,
        name: "Qazi the clever programmer",
        review: "Qazi is creates lots of intuitive tutorials focused on decentralized application and user interfaces for  web3 based applications. ",
        link: "https://www.youtube.com/c/CleverProgrammer"

    }
]
    



export default tutorData;